import { Component, OnInit , Inject} from '@angular/core';
import { CommonmastersService } from "../../../../commonmasters/commonmasters.service";
import { PrintdaybookService } from "../../print/printdaybook.service";
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToasterserviceService } from "../../../../utility/shared/toasterservice.service";
import { IndividualConfig, ToastrService } from 'ngx-toastr';
import { Toastpayload } from "../../../../utility/shared/toastpayload";

@Component({
  selector: 'app-rptdaybookpopup',
  templateUrl: './rptdaybookpopup.component.html',
  styleUrls: ['./rptdaybookpopup.component.css']
})
export class RptdaybookpopupComponent implements OnInit {

  BranchList: any[] = [];
  toast : Toastpayload;

  constructor(private commonmastersService: CommonmastersService,
    private printdaybookService: PrintdaybookService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<RptdaybookpopupComponent>,
    private toasterserviceService: ToasterserviceService,) { }

  ngOnInit() {
      
    this.GetBranchList();
    this.data.BranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
  }

  GetBranchList() {
    this.commonmastersService.GetBranchList().subscribe(data => {
      this.BranchList = data;
    })
  }

  GenerateReports(): void {
    
    this.data.ReportName = "DaybookReport";    
    this.printdaybookService.GenerateReport(this.data);
    this.dialogRef.close();

    // toastr Notification
    this.toast = {
      message: "Please wait, the report is downloading now.!",
      title: 'Report', 
      ic:  {
        timeOut: 8000,
        closeButton: true,
      } as IndividualConfig,
      type: 'info',    
    };

    // this.toast.type = 'info';
    this.toasterserviceService.showToast(this.toast);
  }



}
